const isBotResponseEmpty = (hybridLanguages = {}, botResponses = {}) => {
  const keyExist = Object.keys(hybridLanguages).every((langKey) => {
    if (!botResponses[langKey]) {
      return false;
    }
    return hybridLanguages[langKey].every((hybridLang) => {
      if (!botResponses?.[langKey]?.[hybridLang.script]?.responses?.length) {
        return false;
      }
      return true;
    });
  });
  return !keyExist;
};

export default isBotResponseEmpty;
